<template>
    <div class="p1">
        <div class="flex-row m1 start top list border-end p1">
            <img src="/static/icon/tiku.png" alt="" style="width: 120px; height: 80px" />
            <div class="flex-column">
                <div class="flex-row f20b">{{ value.Name }}</div>
                <div class="flex-row f16g mt20">{{ value.CreateTime }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
        config: Object,
    },
};
</script>
